import {
    Box,
    Drawer,
    List,
    ListItem,
    IconButton,
    Typography,
} from '@mui/material';
import { useLayout } from '../../../contexts/LayoutContext';
import { styled } from '@mui/material/styles';
import Image from '../../Image';
import logo from '../../../assets/images/logo/headerlogo.png';
import { memo, useState } from 'react';

import Attendance from '../../../assets/images/tabbar/Attendance.png';
import Carrier from '../../../assets/images/tabbar/Carrier.png';
import Document from '../../../assets/images/tabbar/Document.png';
import Home from '../../../assets/images/tabbar/Home.png';
import profile from '../../../assets/images/tabbar/profile.png';
import Settings from '../../../assets/images/tabbar/Settings.png';
import Hamburger from '../../../assets/images/tabbar/Hamburger.png';
import Users from '../../../assets/images/tabbar/Users-m.png';
import Logout from '../../../assets/images/tabbar/Logout.png';
import Notification from '../../../assets/images/tabbar/Notification.png';
import Lecture from '../../../assets/images/tabbar/Lecture.png';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import ActiveAttendance from '../../../assets/images/tabbar/Active-Attendance.png';
import ActiveCarrier from '../../../assets/images/tabbar/Active-Carrier.png';
import ActiveDocument from '../../../assets/images/tabbar/Active-Document.png';
import ActiveHome from '../../../assets/images/tabbar/Active-Home.png';
import Activeprofile from '../../../assets/images/tabbar/Active-profile.png';
import ActiveLecture from '../../../assets/images/tabbar/Active-Lecturers.png';
import ActiveSettings from '../../../assets/images/tabbar/Active-Settings.png';
import ActiveUsers from '../../../assets/images/tabbar/Active-Users-m.png';
import ActiveLogout from '../../../assets/images/tabbar/Active-Logout.png';
import ActiveNotification from '../../../assets/images/tabbar/Active-Notification.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import CustomTreeTab from './TreeTab';

const menuItems = [
    { text: 'sidebar.dashboard', icon: Home, activeIcon: ActiveHome, path: '/' },
    { text: 'sidebar.ihreTragerzertifikate', icon: Document, activeIcon: ActiveDocument, path: '/carrier-certificates' },
    { text: 'sidebar.liveWebinare', icon: Lecture, activeIcon: ActiveLecture, path: '/live-webinare' },
    { text: 'sidebar.schriftlichePrufung', icon: Carrier, activeIcon: ActiveCarrier, path: '/schriftliche-pruefung' },
    { text: 'sidebar.mundlichePrufung', icon: Users, activeIcon: ActiveUsers, path: '/muendliche-pruefung' },
    { text: 'sidebar.examHistory', icon: Attendance, activeIcon: ActiveAttendance, path: '/exam-history' },
    { text: 'sidebar.feedbackbogen', icon: Settings, activeIcon: ActiveSettings, path: '/feedbackbogen' },
];

const menuItems2 = [
    { text: 'sidebar.logout', icon: Logout, activeIcon: ActiveLogout, path: '/login' },
];

const StyledBox = styled(Box)(({ theme, collapsed }) => ({
    transition: 'width 0.3s ease-in-out',
    display: 'flex',
    minHeight: '100vh',
    paddingLeft: collapsed == "false" ? "30px" : 0,
    paddingRight: collapsed == "false" ? "30px" : 0,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: collapsed == "false" ? "space-between" : "center"
}));

const TopIcon = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: "center",
    gap: "45px",
    marginTop: "40px",
    width: "100%"
}));

const StyledListItem = styled(ListItem)(({ theme, collapsed, selected }) => ({
    display: 'flex',
    width: collapsed == "false" ? '100%' : "42px",
    justifyContent: collapsed != "false" ? "center" : "flex-start",
    alignItems: "center",
    gap: '10px',
    height: '42px',
    borderRadius: "10px",
    backgroundColor: selected ? theme.palette.action.hover : 'transparent',
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: theme.palette.action.hover,
        '& .MuiTypography-root': {
            color: 'white',
        },
        '& .MuiBox-root': {
            filter: `grayscale(0%)`
        },
    },
    userSelect: "none"
}));

const MenuItem = memo(({ item, index, isCollapsed, navigate, pathname, t, logout, closeMenu }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    var selected = pathname === item.path
    if (item?.tabs) { selected = item?.tabs?.find(tab => pathname?.includes(tab.path)) || showMenu }

    const icon = isHovered || selected ? item.activeIcon : item.icon;

    return (
        <Box
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            sx={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}
        >
            <StyledListItem
                selected={selected}
                collapsed={String(isCollapsed)} key={index}
                onClick={() => {
                    if (item?.tabs) {
                        setShowMenu(!showMenu)
                        return
                    }
                    if (item.text === 'sidebar.logout') {
                        logout()
                    } else {
                        navigate(item.path)
                    }
                    closeMenu?.()
                }}
                href={item.path}
            >
                <Image component="img" src={icon} style={{ color: "red" }} />
                {!isCollapsed && <Typography variant="body2" fontWeight={selected ? "500" : "400"} color={selected ? "white" : "#5C5E64"} width={"100%"} >{t(item.text)}</Typography>}
                {(!isCollapsed && selected && item?.tabs) && <KeyboardArrowDownOutlinedIcon htmlColor='white' sx={{ alignSelf: "flex-end", display: "flex", transform: showMenu ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease" }} />}
            </StyledListItem>
            <Box sx={{ width: "100%", pl: "20px", display: isCollapsed ? "none" : "flex", }}>
                {showMenu && <CustomTreeTab closeMenu={closeMenu} tabs={item.tabs} pathname={pathname} navigate={navigate} isCollapsed={isCollapsed} />}
            </Box>
        </Box>
    )
});

const Sidebar = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isCollapsed, toggleCollapse, mobileOpen, toggleMobileMenu, isMobile, drawerWidth, pathname } = useLayout();

    const closeMenu = () => { if (isMobile) { toggleMobileMenu() } }

    const drawer = (
        <StyledBox collapsed={String(isCollapsed)}>
            <Box sx={{ width: "100%", flexGrow: 1, gap: "30px", display: "flex", flexDirection: "column" }}>
                <TopIcon>
                    {!isCollapsed && <Image src={logo} alt="Logo" style={{ width: '137px', height: '36px' }} />}
                    {!isMobile &&
                        <IconButton onClick={toggleCollapse} sx={{ color: 'black' }}>
                            <Image src={Hamburger} />
                        </IconButton>
                    }
                </TopIcon>
                <Typography color='#1C236D' fontWeight={"600"} width={"100%"} paddingLeft={"17px"} mt={"10px"} variant='caption'>{!isCollapsed ? t('sidebar.main') : ""}</Typography>
                <List sx={{ width: '100%', gap: "10px", display: 'flex', flexDirection: "column", mt: "-20px", alignItems: "center" }}>
                    {menuItems.map((item, index) => (<MenuItem closeMenu={closeMenu} t={t} key={index} index={index} item={item} isCollapsed={isCollapsed} navigate={navigate} pathname={pathname} />))}
                </List>
            </Box>
            <Box sx={{ width: "100%", my: "30px" }}>
                <Typography color='#1C236D' fontWeight={"600"} mt={"30px"} width={"100%"} paddingLeft={"17px"} variant='caption'>{!isCollapsed ? t('sidebar.others') : ""}</Typography>
                <List sx={{ width: '100%', gap: "10px", display: 'flex', flexDirection: "column", mt: "10px", alignItems: "center" }}>
                    {menuItems2.map((item, index) => (<MenuItem closeMenu={closeMenu} logout={logout} t={t} key={index} index={index} item={item} isCollapsed={isCollapsed} navigate={navigate} pathname={pathname} />))}
                </List>
            </Box>
        </StyledBox >
    );

    return (
        <Drawer
            variant={isMobile ? 'temporary' : 'permanent'}
            open={isMobile ? mobileOpen : true}
            onClose={isMobile ? toggleMobileMenu : () => { }}
            ModalProps={{ keepMounted: true }}
            sx={{
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    transition: 'width 0.3s ease-in-out',
                    borderColor: "#F1F1F4"
                },
            }}
        >
            {drawer}
        </Drawer>
    );
};

export default Sidebar;